import { useEffect, useRef, useState } from 'react';
import Titol from 'components/3catinfo/Titol';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import styles from './playeranimat.module.scss';
import __isEmpty from 'lodash/isEmpty';

const PlayerAnimat = (props) => {
    const {
        titolVideoAnimat = '',
        entradetaVideoAnimat = '',
        urlMp4,
        urlWebm,
        urlWmv,
        urlOgv,
        playOnView = true,
        tresholdPlayOnView = 50,
        estil,
        estilFormatVideo = 'format916'
    } = props;
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [isMuted, setIsMuted] = useState(true);

    const stylesPlayer = clsx({
        [styles.content]: true,
        [styles[estil]]: !!estil
    });

    const stylesVideoWrapper = clsx({
        [styles.videoWrapper]: true,
        [styles[estilFormatVideo]]: !__isEmpty(estilFormatVideo)
    });

    const handlePlayPause = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const video = videoRef.current;

        if (!video) return;

        if (isPlaying) {
            video.pause();
        } else {
            video.play();
        }
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        if (!playOnView) return;
        const video = videoRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    video.play();
                    setIsPlaying(true);
                } else {
                    video.pause();
                    setIsPlaying(false);
                }
            },
            {
                threshold: tresholdPlayOnView / 100
            }
        );

        observer.observe(video);
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!urlMp4 && !urlWebm && !urlOgv && !urlWmv) return <></>;
    return (
        <div className={styles.videoAnimat}>
            {titolVideoAnimat && <Titol className={styles.titol} titol={titolVideoAnimat} tag='h3' />}
            {entradetaVideoAnimat && <p className={styles.entradeta}>{entradetaVideoAnimat}</p>}
            <div className={stylesPlayer}>
                <div className={stylesVideoWrapper}>
                    <video ref={videoRef} autoPlay={!playOnView} playsInline muted={isMuted} loop>
                        {urlMp4 && <source src={urlMp4} type='video/mp4' />}
                        {urlWebm && <source src={urlWebm} type='video/webm' />}
                        {urlWmv && <source src={urlWmv} type='video/wmv' />}
                        {urlOgv && <source src={urlOgv} type='video/ogv' />}
                    </video>
                    <div className={styles.controls}>
                        <button onClick={handlePlayPause} className={styles.botoPlayPause}>
                            {!isPlaying ? (
                                <Icona
                                    className={styles.icona}
                                    icona='play_contorn'
                                    alt='Reprodueix el video'
                                    isBlanc={true}
                                    inline={true}
                                />
                            ) : (
                                <Icona
                                    className={styles.icona}
                                    icona='pause_contorn'
                                    alt='Aturar el video'
                                    isBlanc={true}
                                    inline={true}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerAnimat;
